import { WORK_ORDER_BUNDLE_STATUS } from "constants/index";
import {
  Box,
  Chip,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import {
  IMovementWorkOrderBundleFractionationDetail,
  IMovementWorkOrderDetail,
} from "types";
import { STATUS_COLOR, WORK_ORDER_STATUS_LABEL } from "helpers/work_orders";

type WorkOrderFractionationDetailsProps = { order: IMovementWorkOrderDetail };

export default function WorkOrderFractionationDetails({ order }: WorkOrderFractionationDetailsProps) {
  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Box display="flex" gap={2} alignItems="center" flexWrap="wrap">
        <Typography variant="body2"><b>OT #{order.movement.id}</b></Typography>
        <Chip size="small" label={WORK_ORDER_STATUS_LABEL[order.status]} color={STATUS_COLOR[order.status]} />
        <Typography variant="body2">
          {order.completed_bundles} de {order.total_bundles} fardos completados
        </Typography>
      </Box>
      <TableContainer component={Paper} elevation={4} sx={{ p: 1 }}>
        <Table
          size="small"
          aria-label="Detalle de fraccionado de la orden"
        >
          <TableHead
            sx={{
              "*": {
                overflow: "hidden",
                textOverflow: "ellipsis",
                textWrap: "nowrap",
              },
            }}
          >
            <TableRow>
              <TableCell>Fardo</TableCell>
              <TableCell>Código de Artículo</TableCell>
              <TableCell>Descripción</TableCell>
              <TableCell>Lote</TableCell>
              <TableCell>Ubicación</TableCell>
              <TableCell>Origen</TableCell>
              <TableCell align="right">Unidades</TableCell>
              <TableCell align="right">Paquetes</TableCell>
              <TableCell align="right">Sueltos</TableCell>
              <TableCell align="right">Scrap</TableCell>
              <TableCell>Estado</TableCell>
              <TableCell>Operario</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {order.bundles.flatMap((bundle) => {
              const groups: Array<[string, IMovementWorkOrderBundleFractionationDetail]> = [
                ["Disponible", bundle.available],
                ...(bundle.not_available ? [["No disponible", bundle.not_available] as [string, IMovementWorkOrderBundleFractionationDetail]] : []),
              ];
              return groups.map(([source, values]) => (
                <TableRow key={`${bundle.id}-${source}`} hover>
                  <TableCell sx={{ whiteSpace: "nowrap" }}>F-{bundle.lote_externo}</TableCell>
                  <TableCell>{bundle.article.code}</TableCell>
                  <TableCell>{bundle.article.description}</TableCell>
                  <TableCell>{bundle.lote || bundle.lote_externo || "-"}</TableCell>
                  <TableCell>{bundle.destination_location?.code || bundle.location?.code || "-"}</TableCell>
                  <TableCell>{source}</TableCell>
                  <TableCell align="right">{values.amount}</TableCell>
                  <TableCell align="right">{values.packages}</TableCell>
                  <TableCell align="right">{values.loose}</TableCell>
                  <TableCell align="right">{values.scrap}</TableCell>
                  <TableCell>{bundle.completed ? "Completo" : bundle.status === WORK_ORDER_BUNDLE_STATUS.IN_PROCESS ? "En trabajo" : "Pendiente"}</TableCell>
                  <TableCell>{bundle.operator ? `${bundle.operator.first_name} ${bundle.operator.last_name}` : "—"}</TableCell>
                </TableRow>
              ));
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
